import NProgress from 'nprogress' // progress bar
import '@/components/NProgress/nprogress.less' // progress bar custom style
import { hasPermission } from './permission'
import ls from '@/utils/Storage'
import type { Router } from 'vue-router';
import { notification } from 'ant-design-vue';
import store from '@/store'

NProgress.configure({ showSpinner: false })

const whiteList = ['login', 'Action_customer', 'kezhangmm', 'serverCenter', 'androidAd']
const defaultRoutePath = '/'

let isLoadingPermission = false
let pendingPath = ''

// 检查权限数据是否有效
const isValidPermission = (permission: any) => {
    if (!permission) return false
    // 检查是否是数组且有内容
    if (Array.isArray(permission)) {
        return permission.length > 0
    }
    // 如果是对象，检查是否有内容
    if (typeof permission === 'object') {
        return Object.keys(permission).length > 0
    }
    return false
}

export const setupBeforeEach = (router: Router) => {
    router.beforeEach(async (to, from, next) => {
        NProgress.start()

        const token = ls.get('ACCESS_TOKEN')

        console.log('=== 路由守卫 ===')
        console.log('路径:', to.path)
        console.log('有token:', !!token)

        // 🔥 关键修复：检查 token 是否存在但无效
        if (token) {
            // 检查 token 是否过期或格式不正确
            try {
                // 如果 token 是字符串，检查长度（JWT通常较长）
                if (typeof token === 'string' && token.length < 10) {
                    console.warn('检测到无效token，自动清理')
                    ls.remove('ACCESS_TOKEN')
                    ls.remove('PERMISSION')
                    ls.remove('USER_routers')
                    next({ path: '/user/login' })
                    NProgress.done()
                    return
                }
            } catch (e) {
                console.warn('token解析失败，自动清理')
                ls.remove('ACCESS_TOKEN')
                ls.remove('PERMISSION')
                ls.remove('USER_routers')
                next({ path: '/user/login' })
                NProgress.done()
                return
            }
        }

        if (token) {
            if (to.path === '/user/login') {
                next({ path: defaultRoutePath })
                NProgress.done()
                return
            }

            let permission = ls.get('PERMISSION')

            // 🔥 关键修复：检查权限数据是否有效
            if (permission && !isValidPermission(permission)) {
                console.warn('检测到无效的权限数据，自动清理')
                ls.remove('PERMISSION')
                ls.remove('USER_routers')
                permission = null
            }

            // 如果没有权限数据，尝试从后端获取
            if (!permission) {
                if (isLoadingPermission) {
                    if (pendingPath === to.path) {
                        console.warn('⚠️ 检测到死循环，清理缓存并跳转登录')
                        ls.remove('ACCESS_TOKEN')
                        ls.remove('PERMISSION')
                        ls.remove('USER_routers')
                        isLoadingPermission = false
                        pendingPath = ''
                        next({ path: '/user/login' })
                        NProgress.done()
                        return
                    }

                    await new Promise<void>((resolve) => {
                        const checkInterval = setInterval(() => {
                            if (!isLoadingPermission) {
                                clearInterval(checkInterval)
                                resolve()
                            }
                        }, 100)
                    })
                    next({ ...to, replace: true })
                    return
                }

                isLoadingPermission = true
                pendingPath = to.path

                try {
                    console.log('开始加载权限数据...')
                    const routers = await store.dispatch('GenerateRoutes', router)

                    if (routers && routers.length > 0) {
                        console.log('权限加载成功')
                        isLoadingPermission = false
                        pendingPath = ''
                        next({ ...to, replace: true })
                        return
                    } else {
                        console.error('权限加载失败')
                        isLoadingPermission = false
                        pendingPath = ''
                        ls.remove('ACCESS_TOKEN')
                        ls.remove('PERMISSION')
                        ls.remove('USER_routers')
                        notification.error({
                            message: '权限加载失败',
                            description: '未能获取到权限数据，请重新登录'
                        })
                        next({ path: '/user/login' })
                        return
                    }
                } catch (error) {
                    console.error('权限加载异常:', error)
                    isLoadingPermission = false
                    pendingPath = ''
                    ls.remove('ACCESS_TOKEN')
                    ls.remove('PERMISSION')
                    ls.remove('USER_routers')
                    notification.error({
                        message: '权限加载异常',
                        description: '请重新登录'
                    })
                    next({ path: '/user/login' })
                    return
                }
            }

            const canAccess = hasPermission(permission, to)
            if (canAccess) {
                next()
            } else {
                next({ path: '/exception/403' })
            }
        } else {
            if (whiteList.includes(to.name as any)) {
                next()
            } else {
                next({ path: '/user/login', query: { redirect: to.fullPath } })
                NProgress.done()
            }
        }
    })

    router.onError((error) => {
        if (window.env === 'localhost') {
            notification.error({
                message: 'Dynamic import error',
                description: error.stack,
            });
        } else {
            router.push({ name: 'error', params: { errorMsg: error.stack } })
        }
    })
}

export const setupAfterEach = (router: Router) => {
    router.afterEach(() => {
        NProgress.done()
    })
}
